import axios from 'axios';
import {
	GET_EXAM_INSTRUCTION_REQUEST,
	GET_EXAM_INSTRUCTION_SUCCESS,
	GET_EXAM_INSTRUCTION_FAIL,
	MOCK_EXAM_QUESTIONS_REQUEST,
	MOCK_EXAM_QUESTIONS_SUCCESS,
	MOCK_EXAM_QUESTIONS_FAIL,
	CLEAR_ERRORS
} from './../constants/mockConstants';

const _api_path = process.env.REACT_APP_API_BASE_URL || '/api/v1';

const resolveIsJambExam = () => {
	if (typeof window === 'undefined') return false;
	const slug = (localStorage.getItem('examSlug') || '').toLowerCase();
	const name = (localStorage.getItem('examName') || '').toLowerCase();
	return slug === 'jamb-utme' || slug.includes('jamb') || name.includes('jamb');
};

//get all advice
export const getExamInstruction = (id) => async (dispatch) => {
	try {
		dispatch({
			type: GET_EXAM_INSTRUCTION_REQUEST
		});

		const { data } = await axios.get(`${_api_path}/get-exam-instruction/${id}`);
		// console.log("data", data);
		// return;
		dispatch({
			type: GET_EXAM_INSTRUCTION_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: GET_EXAM_INSTRUCTION_FAIL,
			payload: error
		});
	}
};

//get mock exam questions
export const getMockExamQuestions = (examId, examType, subjects, university, questionCount = null, subscriptionId = null, userId = null) => async (dispatch) => {
	// Normalize userId: fall back to localStorage / userInfo if not passed
	if (!userId) {
		const storedUser = localStorage.getItem('userId');
		if (storedUser) {
			userId = storedUser;
		} else {
			try {
				const info = JSON.parse(localStorage.getItem('userInfo') || '{}');
				if (info?._id) userId = info._id;
			} catch (e) {
				// ignore parse errors
			}
		}
	}
	// Normalize subjects into array of ids
	let subjectArray = [];
	if (Array.isArray(subjects)) {
		subjectArray = subjects;
	} else if (typeof subjects === 'string') {
		try {
			const parsed = JSON.parse(subjects);
			if (Array.isArray(parsed)) subjectArray = parsed;
			else if (parsed) subjectArray = [String(parsed)];
		} catch (e) {
			subjectArray = subjects.split(',').map(s => s.trim()).filter(Boolean);
		}
	} else if (subjects) {
		subjectArray = [subjects];
	}
	// Early guard: if we still have no user or subjects, log and dispatch failure gracefully
	if (!userId) {
		console.warn('[getMockExamQuestions] Missing userId; mock questions will return empty');
	}
	if (!subjectArray.length) {
		console.warn('[getMockExamQuestions] No subjects provided');
	}
	try {
		dispatch({
			type: MOCK_EXAM_QUESTIONS_REQUEST
		});

		// Backend supports 'both'; default only if missing
		const normalizedExamType = (!examType) ? 'objective' : examType;

		// JAMB mock limits are enforced server-side (English 60, others 40).
		const isJambExam = resolveIsJambExam();
		const payload = {
			examId,
			examType: normalizedExamType,
			subjects: subjectArray,
			university: Array.isArray(university) ? university : (university ? [university] : []),
			questionLimit: isJambExam
				? undefined
				: (questionCount !== null && questionCount !== undefined ? Number(questionCount) : undefined),
			subscriptionId: subscriptionId || localStorage.getItem('userSubscription') || undefined,
			userId,
			isMock: true,
		};

		if (process.env.REACT_APP_DEBUG_MOCK === 'true') {
			console.log('[getMockExamQuestions] Payload:', payload);
		}

		const { data } = await axios.post(`${_api_path}/get-mock-questions`, payload);
		// console.log("data", data);
		// return;
		dispatch({
			type: MOCK_EXAM_QUESTIONS_SUCCESS,
			payload: data,
			questionCount: data.totalQuestions,
			currentExam: data.exam
		});
	} catch (error) {
		dispatch({
			type: MOCK_EXAM_QUESTIONS_FAIL,
			payload: error
		});
	}
};
